export default "__VITE_ASSET__K07if6uF__"